var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container u-text-center"},[_c('img',{attrs:{"src":_vm.imgUrl}}),_c('h4',[_vm._v(_vm._s(_vm.productName))]),_c('p',[_vm._v("您选择的借款产品")]),_c('span',[_vm._v("正在为您跳转…")])])
}
var staticRenderFns = []

export { render, staticRenderFns }